import { useState } from "react";
import { introsummerimgs } from "../data/galleryimgdata";

const IntroSummer = () => {
     const [selectedImage, setSelectedImage] = useState(null);
     const [currentIndex, setCurrentIndex] = useState(0);

     const openImage = (index) => {
          setCurrentIndex(index);
          setSelectedImage(introsummerimgs[index].image);
     };

     const closeImage = () => {
          setSelectedImage(null);
     };

     const prevImage = () => {
          const newIndex = (currentIndex - 1 + introsummerimgs.length) % introsummerimgs.length;
          setCurrentIndex(newIndex);
          setSelectedImage(introsummerimgs[newIndex].image);
     };

     const nextImage = () => {
          const newIndex = (currentIndex + 1) % introsummerimgs.length;
          setCurrentIndex(newIndex);
          setSelectedImage(introsummerimgs[newIndex].image);
     };

     return (
          <>
               <h1>Introducing Summer</h1>
               <div className="gallery-images-container">
                    {introsummerimgs.map((introsummer, index) => (
                         <img
                              loading="lazy"
                              alt="introsummer"
                              src={introsummer.image}
                              key={introsummer.id}
                              onClick={() => openImage(index)}
                              style={{ cursor: "pointer" }}
                         />
                    ))}
               </div>

               {selectedImage && (
                    <div className="modal">
                         <span className="close" onClick={closeImage}>&times;</span>
                         <button className="prev" onClick={prevImage}>&#10094;</button>
                         <img src={selectedImage} alt="Selected" className="modal-content" />
                         <button className="next" onClick={nextImage}>&#10095;</button>
                    </div>
               )}
          </>
     );
};

export default IntroSummer;
